function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m72 0h312c13.253906 0 24 10.746094 24 24v376h-336zm0 0",
  fill: "#0093ba"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40 32h336v400h-336zm0 0",
  fill: "#2fbadb"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m456 353.65625v-35.3125l-29.601562-7.398438c-2.394532-9.417968-6.140626-18.441406-11.117188-26.785156l15.710938-26.183594-24.96875-24.96875-26.183594 15.710938c-3.894532-2.316406-7.941406-4.375-12.113282-6.160156-4.753906-2.023438-9.660156-3.679688-14.671874-4.949219l-7.398438-29.609375h-35.3125l-7.398438 29.601562c-9.417968 2.394532-18.441406 6.140626-26.785156 11.117188l-26.183594-15.710938-24.96875 24.96875 15.710938 26.183594c-4.976562 8.34375-8.722656 17.367188-11.117188 26.785156l-29.601562 7.398438v35.3125l29.601562 7.398438c2.394532 9.417968 6.140626 18.441406 11.117188 26.785156l-15.710938 26.183594 24.96875 24.96875 26.183594-15.710938c8.34375 4.976562 17.367188 8.722656 26.785156 11.117188l7.398438 29.601562h35.3125l7.398438-29.601562c9.417968-2.394532 18.441406-6.140626 26.785156-11.117188l26.183594 15.710938 24.96875-24.96875-15.710938-26.183594c4.976562-8.34375 8.722656-17.367188 11.117188-26.785156zm-128 38.34375c-30.929688 0-56-25.070312-56-56s25.070312-56 56-56 56 25.070312 56 56-25.070312 56-56 56zm0 0",
  fill: "#ccdce5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328 32v16c0 13.253906 10.746094 24 24 24s24-10.746094 24-24v-16zm0 0",
  fill: "#ffc119"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m352 0c-13.253906 0-24 10.746094-24 24v24c0 13.253906 10.746094 24 24 24h-320c-13.253906 0-24-10.746094-24-24v-24c0-13.253906 10.746094-24 24-24zm0 0",
  fill: "#047fa7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m24 360h120l32 16-32 16h-120c-8.835938 0-16-7.164062-16-16s7.164062-16 16-16zm0 0",
  fill: "#ffc119"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 112h16v160h-16zm0 0",
  fill: "#7ecce6"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m136 112c-21.222656-.027344-41.582031 8.40625-56.566406 23.433594l56.566406 56.566406h80c0-44.183594-35.816406-80-80-80zm0 0",
  fill: "#ffc119"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#0093ba"
}, React.createElement("path", {
  d: "m88 224h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m120 224h80v16h-80zm0 0"
}), React.createElement("path", {
  d: "m72 256h128v16h-128zm0 0"
}), React.createElement("path", {
  d: "m248 136h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m72 288h104v16h-104zm0 0"
}), React.createElement("path", {
  d: "m165.65625 165.65625-11.3125-11.3125 48-48c1.5-1.5 3.535156-2.34375 5.65625-2.34375h104v16h-100.6875zm0 0"
}), React.createElement("path", {
  d: "m328 104h16v16h-16zm0 0"
}), React.createElement("path", {
  d: "m280 136h64v16h-64zm0 0"
}), React.createElement("path", {
  d: "m248 168h96v16h-96zm0 0"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m176 376-32-16h-16v32h16zm0 0",
  fill: "#ea732d"
});

var SvgProject = function SvgProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-4 0 464 464",
    width: "464pt",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project.080cd30c.svg";
export { ForwardRef as ReactComponent };